import { useFieldArray, useForm } from 'react-hook-form';
import { SimilarityDTO } from '../../../BeFi20/api/useOverviewQuery';

interface FormValues {
  comparisonFields: { id: string; selected: boolean }[];
}

export interface BeFi20Props {
  data: {
    comparisons: { id: string; name: string; similarity: SimilarityDTO }[];
    selectedComparisons: string[];
  };
  onSave(selectedComparisons: string[]): void;
  onClose(): void;
}

export const useBeFi20 = ({
  data: { comparisons, selectedComparisons },
  onSave,
  onClose,
}: BeFi20Props) => {
  const formBag = useForm<FormValues>({
    defaultValues: {
      comparisonFields: comparisons.map(comparison => ({
        id: comparison.id,
        selected: selectedComparisons.includes(comparison.id),
      })),
    },
  });
  const { fields } = useFieldArray({
    control: formBag.control,
    name: 'comparisonFields',
    keyName: 'key',
  });
  const watchFieldArray = formBag.watch('comparisonFields');
  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });

  const onSubmit = formBag.handleSubmit((values: FormValues) => {
    const newSelectedComparisons = values.comparisonFields
      .filter(field => field.selected)
      .map(field => field.id);

    onSave(newSelectedComparisons);
    onClose();
  });

  return {
    ...formBag,
    fields: controlledFields,
    onSubmit,
  };
};
